import { useState } from 'react';
import { Button } from 'framework/ui/mui-builder';
import useEngineeringService from '../../engineering/useEngineeringService';
import useReconcileProjectNotifications, {
  PROJECT_NOTIFICATION_SCOPE,
} from '../../shared/notifications/useReconcileProjectNotifications';
import type { ControlData } from '../types';

type PpcLinkActionProps = {
  data: ControlData;
  refetchControlsData: () => Promise<unknown>;
};

export const PpcLinkConfirmAction = ({ data, refetchControlsData }: PpcLinkActionProps) => {
  const { confirmPpcLink } = useEngineeringService();
  const reconcileNotifications = useReconcileProjectNotifications();
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      await confirmPpcLink(String(data.id));
      await reconcileNotifications(String(data.id), [PROJECT_NOTIFICATION_SCOPE.ENGINEERING]).catch(() => undefined);
      await refetchControlsData();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button variant="contained" onClick={handleConfirm} loading={isLoading}>
      Confirm
    </Button>
  );
};
